import React from 'react';
import { FormattedMessage, useIntl } from 'react-intl';
import { Icon, Label, Popup } from 'semantic-ui-react';

const CohortCountsLabel = ({
  total,
  count,
  onClick,
  showCounts,
  hideEntities,
  message = 'cohort.counts.total.title',
  color,
}) => {
  const intl = useIntl();
  return (
    <>
      { hideEntities && (
        <Label color={color}>
          <FormattedMessage id={message} values={{ count, total }} />
        </Label>
      )}
      { !hideEntities && (
        <Popup
          content={intl.formatMessage({ id: 'cohort.counts.entities.show' })}
          trigger={(
            <Label as="a" color={color} onClick={onClick}>
              <Icon name={showCounts ? 'chevron up' : 'chevron down'} />
              <FormattedMessage id={message} values={{ count, total }} />
            </Label>
          )}
        />
      )}
    </>
  );
};

export default CohortCountsLabel;
